import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Container, Typography } from '@mui/material'
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCaretDown } from '@fortawesome/pro-solid-svg-icons'
import { SectionsHeading } from '../../../../components/headings'

export default function Faq() {
  const { t, i18n } = useTranslation()

  return (
    <main>
      <Box
        width={'100%'}
        component={'section'}
        sx={{
          padding: { xs: '110px 0 130px 0', md: '100px 0 ', lg: '80px 0' },
        }}
      >
        <Box width={'100%'} position={'relative'}>
          <Container
            maxWidth={'lg'}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              rowGap: '40px',
            }}
          >
            <SectionsHeading type={'animation'}>
              {t('faq.titre')}
            </SectionsHeading>
            {i18n.language === 'fr' ? (
              <div>
                <Accordion defaultExpanded>
                  <AccordionSummary
                    sx={{ fontWeight: 'bold' }}
                    expandIcon={<FontAwesomeIcon icon={faCaretDown} />}
                    aria-controls="panel1-content"
                    id="panel1-header"
                  >
                    Qu'est-ce que JoberTech ?
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography variant={'p'}>
                      JoberTech est un Job Board spécialisé dans les métiers de
                      l'IT et du Digital en Suisse.
                    </Typography>
                    <br></br>
                    <br></br>
                    <Typography variant={'p'}>
                      Notre plateforme met en relation les
                      entreprises/organisations qui recrutent et les
                      professionnels de l'informatique et du digital au sens
                      large comme des profils commerciaux, procurement ou autre
                      dans les domaines cités précédemment pour tout type de
                      contrat : emploi fixe, mission freelance, consulting,
                      contrat temporaire ou mandat, stage, ...
                    </Typography>
                  </AccordionDetails>
                </Accordion>
                <Accordion>
                  <AccordionSummary
                    sx={{ fontWeight: 'bold' }}
                    expandIcon={<FontAwesomeIcon icon={faCaretDown} />}
                    aria-controls="panel2-content"
                    id="panel2-header"
                  >
                    Pourquoi choisir JoberTech ?
                  </AccordionSummary>
                  <AccordionDetails>
                    Contrairement aux plateformes généralistes, JoberTech est
                    entièrement dédié aux métiers de l'IT et du Digital.
                    <br></br>
                    Les entreprises accèdent à des profils ciblés et les
                    candidats découvrent des opportunités adaptées à leur
                    expertise.
                    <br></br>
                    Nous avons un réseau étendu et une base de données déjà bien
                    fournie avec des milliers de profils qui n’attendent que
                    vous.
                  </AccordionDetails>
                </Accordion>
                <Accordion>
                  <AccordionSummary
                    sx={{ fontWeight: 'bold' }}
                    expandIcon={<FontAwesomeIcon icon={faCaretDown} />}
                    aria-controls="panel3-content"
                    id="panel3-header"
                  >
                    Qui peut s'inscrire sur JoberTech ?
                  </AccordionSummary>
                  <AccordionDetails>
                    Tous les professionnels de l'IT et du Digital (liste non
                    exhaustive):
                    <ul>
                      <li>Développeurs</li>
                      <li>Ingénieurs systèmes et réseaux</li>
                      <li>Experts cloud</li>
                      <li>Consultants ERP, CRM et SAP</li>
                      <li>Product Owners</li>
                      <li>Chefs de projet</li>
                      <li>Experts cybersécurité</li>
                      <li>Data Analysts</li>
                      <li>Data Engineers</li>
                      <li>Data Scientists</li>
                      <li>Architectes IT</li>
                      <li>UX/UI Designers</li>
                      <li>Managers IT</li>
                      <li>CTO, CIO et profils C-Level</li>
                      <li>Commerciaux</li>
                      <li>
                        Les métiers supports comme les achats dans le domaine IT{' '}
                      </li>
                    </ul>
                  </AccordionDetails>
                </Accordion>
                <Accordion>
                  <AccordionSummary
                    sx={{ fontWeight: 'bold' }}
                    expandIcon={<FontAwesomeIcon icon={faCaretDown} />}
                    aria-controls="panel4-content"
                    id="panel4-header"
                  >
                    L'inscription est-elle gratuite pour les candidats ?
                  </AccordionSummary>
                  <AccordionDetails>
                    Oui, l'inscription et la création d'un profil sont
                    entièrement gratuites.<br></br>
                    Vous pouvez consulter les offres, être visible auprès des
                    recruteurs et postuler librement.
                  </AccordionDetails>
                </Accordion>
                <Accordion>
                  <AccordionSummary
                    sx={{ fontWeight: 'bold' }}
                    expandIcon={<FontAwesomeIcon icon={faCaretDown} />}
                    aria-controls="panel4-content"
                    id="panel4-header"
                  >
                    Dois-je être en recherche active pour m'inscrire ?
                  </AccordionSummary>
                  <AccordionDetails>
                    Non.<br></br>
                    Vous pouvez créer votre profil simplement pour rester à
                    l'écoute du marché, développer votre réseau ou être informé
                    des opportunités correspondant à votre expertise.
                  </AccordionDetails>
                </Accordion>
                <Accordion>
                  <AccordionSummary
                    sx={{ fontWeight: 'bold' }}
                    expandIcon={<FontAwesomeIcon icon={faCaretDown} />}
                    aria-controls="panel4-content"
                    id="panel4-header"
                  >
                    Puis-je m'inscrire si je suis déjà en poste ?
                  </AccordionSummary>
                  <AccordionDetails>
                    Oui.<br></br>
                    De nombreux professionnels utilisent JoberTech pour
                    effectuer une veille du marché ou étudier de nouvelles
                    opportunités en toute confidentialité.
                  </AccordionDetails>
                </Accordion>
                <Accordion>
                  <AccordionSummary
                    sx={{ fontWeight: 'bold' }}
                    expandIcon={<FontAwesomeIcon icon={faCaretDown} />}
                    aria-controls="panel4-content"
                    id="panel4-header"
                  >
                    Je réside hors de Suisse. Puis-je utiliser JoberTech ?
                  </AccordionSummary>
                  <AccordionDetails>
                    Oui.<br></br>
                    Les entreprises présentes sur la plateforme recrutent des
                    talents locaux mais également des profils internationaux
                    selon leurs besoins et les conditions légales applicables.
                  </AccordionDetails>
                </Accordion>
                <Accordion>
                  <AccordionSummary
                    sx={{ fontWeight: 'bold' }}
                    expandIcon={<FontAwesomeIcon icon={faCaretDown} />}
                    aria-controls="panel4-content"
                    id="panel4-header"
                  >
                    Quels types de contrats sont proposés ?
                  </AccordionSummary>
                  <AccordionDetails>
                    Selon les entreprises et les missions, vous pouvez trouver :
                    <ul>
                      <li>CDI</li>
                      <li>CDD</li>
                      <li>Missions freelance</li>
                      <li>Consulting</li>
                      <li>Contrats temporaires</li>
                      <li>Management de transition</li>
                      <li>Prestations de services / Délégation</li>
                    </ul>
                  </AccordionDetails>
                </Accordion>
                <Accordion>
                  <AccordionSummary
                    sx={{ fontWeight: 'bold' }}
                    expandIcon={<FontAwesomeIcon icon={faCaretDown} />}
                    aria-controls="panel4-content"
                    id="panel4-header"
                  >
                    Comment postuler à une offre ?
                  </AccordionSummary>
                  <AccordionDetails>
                    Il vous suffit de créer votre profil puis de postuler
                    directement aux opportunités qui vous intéressent.
                  </AccordionDetails>
                </Accordion>
                <Accordion>
                  <AccordionSummary
                    sx={{ fontWeight: 'bold' }}
                    expandIcon={<FontAwesomeIcon icon={faCaretDown} />}
                    aria-controls="panel4-content"
                    id="panel4-header"
                  >
                    Puis-je être contacté directement par des recruteurs ?
                  </AccordionSummary>
                  <AccordionDetails>
                    Oui.<br></br>
                    Les recruteurs peuvent vous contacter lorsqu'ils identifient
                    une adéquation entre votre profil et leurs besoins.
                  </AccordionDetails>
                </Accordion>
                <Accordion>
                  <AccordionSummary
                    sx={{ fontWeight: 'bold' }}
                    expandIcon={<FontAwesomeIcon icon={faCaretDown} />}
                    aria-controls="panel4-content"
                    id="panel4-header"
                  >
                    Comment modifier mon profil ?
                  </AccordionSummary>
                  <AccordionDetails>
                    Vous pouvez mettre à jour à tout moment :
                    <ul>
                      <li>Vos compétences</li>
                      <li>Vos expériences</li>
                      <li>Votre disponibilité</li>
                      <li>Votre mobilité</li>
                      <li>Vos préférences contractuelles</li>
                    </ul>
                  </AccordionDetails>
                </Accordion>
                <Accordion>
                  <AccordionSummary
                    sx={{ fontWeight: 'bold' }}
                    expandIcon={<FontAwesomeIcon icon={faCaretDown} />}
                    aria-controls="panel4-content"
                    id="panel4-header"
                  >
                    Je ne trouve pas mon métier ou une compétence dans la liste.
                  </AccordionSummary>
                  <AccordionDetails>
                    Contactez-nous à :{' '}
                    <a href="mailto:contact@jobertech.com">
                      contact@jobertech.com
                    </a>{' '}
                    <br></br>
                    Notre équipe enrichit régulièrement les catégories et
                    référentiels de compétences.
                  </AccordionDetails>
                </Accordion>
                <Accordion>
                  <AccordionSummary
                    sx={{ fontWeight: 'bold' }}
                    expandIcon={<FontAwesomeIcon icon={faCaretDown} />}
                    aria-controls="panel4-content"
                    id="panel4-header"
                  >
                    Comment supprimer mon compte ?
                  </AccordionSummary>
                  <AccordionDetails>
                    Vous pouvez supprimer votre compte depuis votre espace
                    personnel ou nous contacter à :{' '}
                    <a href="mailto:contact@jobertech.com">
                      contact@jobertech.com
                    </a>
                  </AccordionDetails>
                </Accordion>
                <Accordion>
                  <AccordionSummary
                    sx={{ fontWeight: 'bold' }}
                    expandIcon={<FontAwesomeIcon icon={faCaretDown} />}
                    aria-controls="panel4-content"
                    id="panel4-header"
                  >
                    Pourquoi publier sur JoberTech ?
                  </AccordionSummary>
                  <AccordionDetails>
                    JoberTech est spécialisé exclusivement dans les métiers de
                    l'IT et du Digital.<br></br>
                    Vous diffusez vos opportunités auprès d'une audience ciblée
                    composée de professionnels qualifiés et locaux.
                  </AccordionDetails>
                </Accordion>
                <Accordion>
                  <AccordionSummary
                    sx={{ fontWeight: 'bold' }}
                    expandIcon={<FontAwesomeIcon icon={faCaretDown} />}
                    aria-controls="panel4-content"
                    id="panel4-header"
                  >
                    Quels types d'entreprises utilisent JoberTech ?
                  </AccordionSummary>
                  <AccordionDetails>
                    Nous travaillons avec :
                    <ul>
                      <li>PME</li>
                      <li>Grandes entreprises</li>
                      <li>Startups</li>
                      <li>Scale-ups</li>
                      <li>ESN / sociétés de services</li>
                      <li>Cabinets de placement</li>
                      <li>Cabinets de conseil</li>
                      <li>Organisations publiques/étatiques</li>
                    </ul>
                  </AccordionDetails>
                </Accordion>
                <Accordion>
                  <AccordionSummary
                    sx={{ fontWeight: 'bold' }}
                    expandIcon={<FontAwesomeIcon icon={faCaretDown} />}
                    aria-controls="panel4-content"
                    id="panel4-header"
                  >
                    Quels profils puis-je recruter ?
                  </AccordionSummary>
                  <AccordionDetails>
                    Tous les profils IT & Digital :
                    <ul>
                      <li>Commerciaux </li>
                      <li>Techniques</li>
                      <li>Métiers / Fonctionnels</li>
                      <li>Management</li>
                      <li>Direction</li>
                    </ul>
                  </AccordionDetails>
                </Accordion>
                <Accordion>
                  <AccordionSummary
                    sx={{ fontWeight: 'bold' }}
                    expandIcon={<FontAwesomeIcon icon={faCaretDown} />}
                    aria-controls="panel4-content"
                    id="panel4-header"
                  >
                    Puis-je publier plusieurs offres d’emploi ?
                  </AccordionSummary>
                  <AccordionDetails>
                    Oui.<br></br>
                    Le nombre d'offres disponibles dépend de l'abonnement ou de
                    l’offre choisie.
                  </AccordionDetails>
                </Accordion>
                <Accordion>
                  <AccordionSummary
                    sx={{ fontWeight: 'bold' }}
                    expandIcon={<FontAwesomeIcon icon={faCaretDown} />}
                    aria-controls="panel4-content"
                    id="panel4-header"
                  >
                    Puis-je accéder à une base de talents ?
                  </AccordionSummary>
                  <AccordionDetails>
                    Prochainement mais pas pour le moment.
                  </AccordionDetails>
                </Accordion>
                <Accordion>
                  <AccordionSummary
                    sx={{ fontWeight: 'bold' }}
                    expandIcon={<FontAwesomeIcon icon={faCaretDown} />}
                    aria-controls="panel4-content"
                    id="panel4-header"
                  >
                    Puis-je recruter pour des missions freelances ?
                  </AccordionSummary>
                  <AccordionDetails>
                    Oui.<br></br>
                    JoberTech permet de recruter aussi bien pour des postes
                    permanents que pour des missions ponctuelles ou du
                    consulting.
                  </AccordionDetails>
                </Accordion>
                <Accordion>
                  <AccordionSummary
                    sx={{ fontWeight: 'bold' }}
                    expandIcon={<FontAwesomeIcon icon={faCaretDown} />}
                    aria-controls="panel4-content"
                    id="panel4-header"
                  >
                    Comment fonctionne l'abonnement recruteur ?
                  </AccordionSummary>
                  <AccordionDetails>
                    Vous choisissez la formule qui correspond à vos besoins afin
                    de :
                    <ul>
                      <li>Publier des offres</li>
                      <li>Contacter des candidats</li>
                      <li>Développer votre visibilité employeur</li>
                    </ul>
                  </AccordionDetails>
                </Accordion>
                <Accordion>
                  <AccordionSummary
                    sx={{ fontWeight: 'bold' }}
                    expandIcon={<FontAwesomeIcon icon={faCaretDown} />}
                    aria-controls="panel4-content"
                    id="panel4-header"
                  >
                    Les candidats sont-ils principalement basés en Suisse ?
                  </AccordionSummary>
                  <AccordionDetails>
                    La plateforme attire principalement des talents intéressés
                    par le marché suisse et la Suisse romande, tout en restant
                    ouverte à des profils internationaux. Nous avons quelques
                    candidats de Suisse Alémanique car nous avons des clients
                    sur cette zone.
                  </AccordionDetails>
                </Accordion>
                <Accordion>
                  <AccordionSummary
                    sx={{ fontWeight: 'bold' }}
                    expandIcon={<FontAwesomeIcon icon={faCaretDown} />}
                    aria-controls="panel4-content"
                    id="panel4-header"
                  >
                    En quoi JoberTech est-il différent d'un job board
                    traditionnel ?
                  </AccordionSummary>
                  <AccordionDetails>
                    JoberTech ne se limite pas à la diffusion d'annonces.
                    <br></br>
                    La plateforme combine :
                    <ul>
                      <li>Un écosystème spécialisé IT & Digital</li>
                      <li>Des outils de matching intelligents</li>
                      <li>Une audience ciblée</li>
                      <li>Des profils qualifiés</li>
                      <li>Des profils locaux </li>
                      <li>Une meilleure compréhension des métiers </li>
                      <li>Des recrutements plus pertinents </li>
                      <li>
                        Des fonctionnalités basées sur l'intelligence
                        artificielle{' '}
                      </li>
                      <li>
                        Une visioconférence possible directement sur la
                        plateforme{' '}
                      </li>
                      <li>
                        Une mise en relation simplifiée entre talents et
                        recruteurs{' '}
                      </li>
                    </ul>
                    <br></br>
                    L'objectif est de rendre les recrutements plus rapides, plus
                    pertinents et plus efficaces pour toutes les parties.
                  </AccordionDetails>
                </Accordion>
                <Accordion>
                  <AccordionSummary
                    sx={{ fontWeight: 'bold' }}
                    expandIcon={<FontAwesomeIcon icon={faCaretDown} />}
                    aria-controls="panel4-content"
                    id="panel4-header"
                  >
                    Comment JoberTech m'aide-t-il à trouver les opportunités les
                    plus pertinentes ?
                  </AccordionSummary>
                  <AccordionDetails>
                    JoberTech utilise un moteur de matching qui analyse les
                    compétences, l'expérience, les technologies maîtrisées et
                    les préférences des candidats afin de leur proposer les
                    opportunités les plus pertinentes. <br></br>
                    L'objectif est de vous faire gagner du temps en mettant en
                    avant les offres qui correspondent réellement à votre
                    profil.
                  </AccordionDetails>
                </Accordion>
                <Accordion>
                  <AccordionSummary
                    sx={{ fontWeight: 'bold' }}
                    expandIcon={<FontAwesomeIcon icon={faCaretDown} />}
                    aria-controls="panel4-content"
                    id="panel4-header"
                  >
                    Comment fonctionne le matching entre les candidats et les
                    entreprises ?
                  </AccordionSummary>
                  <AccordionDetails>
                    Le matching permet de rapprocher les besoins des entreprises
                    et les profils des candidats sur la base de multiples
                    critères :
                    <ul>
                      <li>Compétences techniques</li>
                      <li>Expérience</li>
                      <li>Localisation</li>
                      <li>Type de contrat recherché</li>
                      <li>Disponibilité </li>
                      <li>Domaines d'expertise</li>
                    </ul>
                    Cela permet aux recruteurs d'identifier plus rapidement les
                    profils adaptés et aux candidats de découvrir des
                    opportunités en adéquation avec leurs attentes.
                  </AccordionDetails>
                </Accordion>
                <Accordion>
                  <AccordionSummary
                    sx={{ fontWeight: 'bold' }}
                    expandIcon={<FontAwesomeIcon icon={faCaretDown} />}
                    aria-controls="panel4-content"
                    id="panel4-header"
                  >
                    JoberTech utilise-t-il l'intelligence artificielle ?
                  </AccordionSummary>
                  <AccordionDetails>
                    Oui.<br></br>
                    Nous intégrons progressivement des fonctionnalités basées
                    sur l'intelligence artificielle afin d'améliorer
                    l'expérience des candidats et des recruteurs.<br></br>
                    Notre objectif est de simplifier les recherches, faciliter
                    les mises en relation et aider chacun à prendre de
                    meilleures décisions.
                  </AccordionDetails>
                </Accordion>
                <Accordion>
                  <AccordionSummary
                    sx={{ fontWeight: 'bold' }}
                    expandIcon={<FontAwesomeIcon icon={faCaretDown} />}
                    aria-controls="panel4-content"
                    id="panel4-header"
                  >
                    Puis-je obtenir une estimation de mon salaire grâce à
                    JoberTech ?
                  </AccordionSummary>
                  <AccordionDetails>
                    Oui.<br></br>
                    JoberTech propose un outil d'estimation salariale basé sur
                    l'intelligence artificielle qui permet aux candidats
                    d'obtenir une indication de leur valeur sur le marché en
                    fonction de leur profil, de leur expérience, de leur
                    localisation et de leurs compétences.<br></br>
                    Cette estimation permet de mieux se positionner sur le
                    marché de l'emploi.
                  </AccordionDetails>
                </Accordion>
                <Accordion>
                  <AccordionSummary
                    sx={{ fontWeight: 'bold' }}
                    expandIcon={<FontAwesomeIcon icon={faCaretDown} />}
                    aria-controls="panel4-content"
                    id="panel4-header"
                  >
                    Comment JoberTech aide-t-il les entreprises à définir leurs
                    besoins de recrutement ?
                  </AccordionSummary>
                  <AccordionDetails>
                    Grâce à l'intelligence artificielle, JoberTech accompagne
                    les recruteurs dans la formalisation de leurs besoins.
                    <br></br>
                    L'outil aide à structurer les attentes, identifier les
                    compétences clés recherchées et rédiger des descriptions de
                    poste plus précises afin d'attirer les profils les plus
                    pertinents.
                  </AccordionDetails>
                </Accordion>
                <Accordion>
                  <AccordionSummary
                    sx={{ fontWeight: 'bold' }}
                    expandIcon={<FontAwesomeIcon icon={faCaretDown} />}
                    aria-controls="panel4-content"
                    id="panel4-header"
                  >
                    Comment JoberTech m'aide-t-il à rédiger une offre d'emploi ?
                  </AccordionSummary>
                  <AccordionDetails>
                    Nos outils assistés par intelligence artificielle peuvent
                    aider les recruteurs à créer ou enrichir leurs offres
                    d'emploi en suggérant :
                    <ul>
                      <li>Les compétences recherchées</li>
                      <li>Les responsabilités du poste</li>
                      <li>Les technologies associées</li>
                      <li>Les critères de sélection pertinents</li>
                    </ul>
                    Cela permet de gagner du temps tout en améliorant la qualité
                    des annonces publiées.
                  </AccordionDetails>
                </Accordion>
                <Accordion>
                  <AccordionSummary
                    sx={{ fontWeight: 'bold' }}
                    expandIcon={<FontAwesomeIcon icon={faCaretDown} />}
                    aria-controls="panel4-content"
                    id="panel4-header"
                  >
                    Comment obtenir une démonstration ?
                  </AccordionSummary>
                  <AccordionDetails>
                    Vous pouvez tester via l’offre d’essai de 10 jours et/ou
                    nous contacter à{' '}
                    <a href="mailto:contact@jobertech.com">
                      contact@jobertech.com
                    </a>
                  </AccordionDetails>
                </Accordion>
                <Accordion>
                  <AccordionSummary
                    sx={{ fontWeight: 'bold' }}
                    expandIcon={<FontAwesomeIcon icon={faCaretDown} />}
                    aria-controls="panel4-content"
                    id="panel4-header"
                  >
                    Si j’ai besoin d’être accompagné pour un recrutement,
                    comment faut-il faire ?
                  </AccordionSummary>
                  <AccordionDetails>
                    Vous pouvez adresser votre demande à{' '}
                    <a href="mailto:recrutement@jobertech.com">
                      recrutement@jobertech.com
                    </a>
                  </AccordionDetails>
                </Accordion>
                <Accordion>
                  <AccordionSummary
                    sx={{ fontWeight: 'bold' }}
                    expandIcon={<FontAwesomeIcon icon={faCaretDown} />}
                    aria-controls="panel4-content"
                    id="panel4-header"
                  >
                    Si je rencontre un problème technique ?
                  </AccordionSummary>
                  <AccordionDetails>
                    Vous pouvez écrire à{' '}
                    <a href="mailto:support@jobertech.com">
                      support@jobertech.com
                    </a>
                  </AccordionDetails>
                </Accordion>
              </div>
            ) : (
              <div>
                <Accordion defaultExpanded>
                  <AccordionSummary
                    sx={{ fontWeight: 'bold' }}
                    expandIcon={<FontAwesomeIcon icon={faCaretDown} />}
                    aria-controls="panel1-content"
                    id="panel1-header"
                  >
                    What is JoberTech?
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography variant={'p'}>
                      JoberTech is a specialized IT & Digital Job Board focused
                      on the Swiss market.
                    </Typography>
                    <br></br>
                    <br></br>
                    <Typography variant={'p'}>
                      Our platform connects companies and organizations looking
                      to hire with professionals working in IT, Digital, and
                      related business functions such as Sales, Procurement, and
                      other roles supporting the technology sector. <br></br>
                      We facilitate connections for all types of contracts,
                      including permanent positions, freelance assignments,
                      consulting engagements, temporary contracts, internships,
                      and more.
                    </Typography>
                  </AccordionDetails>
                </Accordion>
                <Accordion>
                  <AccordionSummary
                    sx={{ fontWeight: 'bold' }}
                    expandIcon={<FontAwesomeIcon icon={faCaretDown} />}
                    aria-controls="panel2-content"
                    id="panel2-header"
                  >
                    Why choose JoberTech?
                  </AccordionSummary>
                  <AccordionDetails>
                    Unlike general job platforms, JoberTech is exclusively
                    dedicated to IT and Digital professions.
                    <br></br>
                    Companies gain access to highly targeted talent, while
                    candidates discover opportunities that match their skills
                    and expertise.
                    <br></br>
                    We have an extensive network and a well-established database
                    containing thousands of profiles ready to connect with
                    employers.
                  </AccordionDetails>
                </Accordion>
                <Accordion>
                  <AccordionSummary
                    sx={{ fontWeight: 'bold' }}
                    expandIcon={<FontAwesomeIcon icon={faCaretDown} />}
                    aria-controls="panel3-content"
                    id="panel3-header"
                  >
                    Who can join JoberTech?
                  </AccordionSummary>
                  <AccordionDetails>
                    All IT and Digital professionals are welcome, including
                    (non-exhaustive list):
                    <ul>
                      <li>Software Developers</li>
                      <li>System & Network Engineers</li>
                      <li>Cloud Experts</li>
                      <li>ERP, CRM & SAP Consultants</li>
                      <li>Product Owners</li>
                      <li>Project Managers</li>
                      <li>Cybersecurity Specialists</li>
                      <li>Data Analysts</li>
                      <li>Data Engineers</li>
                      <li>Data Scientists</li>
                      <li>IT Architects</li>
                      <li>UX/UI Designers</li>
                      <li>IT Managers</li>
                      <li>CTOs, CIOs and C-Level Executives</li>
                      <li>Sales Professionals</li>
                      <li>
                        Support Functions such as IT Procurement and Purchasing
                        Specialists
                      </li>
                    </ul>
                  </AccordionDetails>
                </Accordion>
                <Accordion>
                  <AccordionSummary
                    sx={{ fontWeight: 'bold' }}
                    expandIcon={<FontAwesomeIcon icon={faCaretDown} />}
                    aria-controls="panel4-content"
                    id="panel4-header"
                  >
                    Is registration free for candidates?
                  </AccordionSummary>
                  <AccordionDetails>
                    Yes, Creating an account and building your profile is
                    completely free.<br></br>
                    You can browse job opportunities, increase your visibility
                    to recruiters, and apply freely.
                  </AccordionDetails>
                </Accordion>
                <Accordion>
                  <AccordionSummary
                    sx={{ fontWeight: 'bold' }}
                    expandIcon={<FontAwesomeIcon icon={faCaretDown} />}
                    aria-controls="panel4-content"
                    id="panel4-header"
                  >
                    Do I need to be actively looking for a job to register?
                  </AccordionSummary>
                  <AccordionDetails>
                    No.<br></br>
                    You can create a profile simply to stay informed about the
                    market, expand your professional network, or discover
                    opportunities that match your expertise.
                  </AccordionDetails>
                </Accordion>
                <Accordion>
                  <AccordionSummary
                    sx={{ fontWeight: 'bold' }}
                    expandIcon={<FontAwesomeIcon icon={faCaretDown} />}
                    aria-controls="panel4-content"
                    id="panel4-header"
                  >
                    Can I register if I am already employed?
                  </AccordionSummary>
                  <AccordionDetails>
                    Yes.<br></br>
                    Many professionals use JoberTech to monitor the market and
                    explore new career opportunities confidentially.
                  </AccordionDetails>
                </Accordion>
                <Accordion>
                  <AccordionSummary
                    sx={{ fontWeight: 'bold' }}
                    expandIcon={<FontAwesomeIcon icon={faCaretDown} />}
                    aria-controls="panel4-content"
                    id="panel4-header"
                  >
                    I live outside Switzerland. Can I use JoberTech?
                  </AccordionSummary>
                  <AccordionDetails>
                    Yes.<br></br>
                    Companies on the platform recruit both local and
                    international talent depending on their needs and applicable
                    legal requirements.
                  </AccordionDetails>
                </Accordion>
                <Accordion>
                  <AccordionSummary
                    sx={{ fontWeight: 'bold' }}
                    expandIcon={<FontAwesomeIcon icon={faCaretDown} />}
                    aria-controls="panel4-content"
                    id="panel4-header"
                  >
                    What types of contracts are available?
                  </AccordionSummary>
                  <AccordionDetails>
                    Depending on the company and opportunity, you may find :
                    <ul>
                      <li>Permanent Positions</li>
                      <li>Fixed-Term Contracts</li>
                      <li>Freelance Assignments</li>
                      <li>Consulting Engagements</li>
                      <li>Temporary Contracts</li>
                      <li>Interim Management Roles</li>
                      <li>Staff Augmentation / Contracting Services</li>
                    </ul>
                  </AccordionDetails>
                </Accordion>
                <Accordion>
                  <AccordionSummary
                    sx={{ fontWeight: 'bold' }}
                    expandIcon={<FontAwesomeIcon icon={faCaretDown} />}
                    aria-controls="panel4-content"
                    id="panel4-header"
                  >
                    How do I apply for a job?
                  </AccordionSummary>
                  <AccordionDetails>
                    Simply create your profile and apply directly to the
                    opportunities that interest you.
                  </AccordionDetails>
                </Accordion>
                <Accordion>
                  <AccordionSummary
                    sx={{ fontWeight: 'bold' }}
                    expandIcon={<FontAwesomeIcon icon={faCaretDown} />}
                    aria-controls="panel4-content"
                    id="panel4-header"
                  >
                    Can recruiters contact me directly?
                  </AccordionSummary>
                  <AccordionDetails>
                    Yes.<br></br>
                    Recruiters may contact you when they identify a strong match
                    between your profile and their hiring needs.
                  </AccordionDetails>
                </Accordion>
                <Accordion>
                  <AccordionSummary
                    sx={{ fontWeight: 'bold' }}
                    expandIcon={<FontAwesomeIcon icon={faCaretDown} />}
                    aria-controls="panel4-content"
                    id="panel4-header"
                  >
                    How can I update my profile?
                  </AccordionSummary>
                  <AccordionDetails>
                    You can update your profile at any time, including :
                    <ul>
                      <li>Skills</li>
                      <li>Professional Experience</li>
                      <li>Availability</li>
                      <li>Geographic Mobility</li>
                      <li>Contract Preferences</li>
                    </ul>
                  </AccordionDetails>
                </Accordion>
                <Accordion>
                  <AccordionSummary
                    sx={{ fontWeight: 'bold' }}
                    expandIcon={<FontAwesomeIcon icon={faCaretDown} />}
                    aria-controls="panel4-content"
                    id="panel4-header"
                  >
                    I cannot find my job title or a specific skill.
                  </AccordionSummary>
                  <AccordionDetails>
                    Please contact us at :{' '}
                    <a href="mailto:contact@jobertech.com">
                      contact@jobertech.com
                    </a>{' '}
                    <br></br>
                    Our team continuously updates our job categories and skills
                    database.
                  </AccordionDetails>
                </Accordion>
                <Accordion>
                  <AccordionSummary
                    sx={{ fontWeight: 'bold' }}
                    expandIcon={<FontAwesomeIcon icon={faCaretDown} />}
                    aria-controls="panel4-content"
                    id="panel4-header"
                  >
                    How do I delete my account?
                  </AccordionSummary>
                  <AccordionDetails>
                    You can delete your account directly from your personal
                    dashboard or contact us at :{' '}
                    <a href="mailto:contact@jobertech.com">
                      contact@jobertech.com
                    </a>
                  </AccordionDetails>
                </Accordion>
                <Accordion>
                  <AccordionSummary
                    sx={{ fontWeight: 'bold' }}
                    expandIcon={<FontAwesomeIcon icon={faCaretDown} />}
                    aria-controls="panel4-content"
                    id="panel4-header"
                  >
                    Why post jobs on JoberTech?
                  </AccordionSummary>
                  <AccordionDetails>
                    JoberTech specializes exclusively in IT and Digital
                    professions.<br></br>
                    Your opportunities are promoted to a highly targeted
                    audience of qualified and local professionals.
                  </AccordionDetails>
                </Accordion>
                <Accordion>
                  <AccordionSummary
                    sx={{ fontWeight: 'bold' }}
                    expandIcon={<FontAwesomeIcon icon={faCaretDown} />}
                    aria-controls="panel4-content"
                    id="panel4-header"
                  >
                    What types of organizations use JoberTech?
                  </AccordionSummary>
                  <AccordionDetails>
                    We work with :
                    <ul>
                      <li>SMEs</li>
                      <li>Large Enterprises</li>
                      <li>Startups</li>
                      <li>Scale-ups</li>
                      <li>IT Services Companies (ESNs)</li>
                      <li>Recruitment Agencies</li>
                      <li>Consulting Firms</li>
                      <li>
                        Public Sector Organizations and Government Institutions
                      </li>
                    </ul>
                  </AccordionDetails>
                </Accordion>
                <Accordion>
                  <AccordionSummary
                    sx={{ fontWeight: 'bold' }}
                    expandIcon={<FontAwesomeIcon icon={faCaretDown} />}
                    aria-controls="panel4-content"
                    id="panel4-header"
                  >
                    What types of profiles can I recruit?
                  </AccordionSummary>
                  <AccordionDetails>
                    All IT & Digital profiles, including :
                    <ul>
                      <li>Sales Professionals </li>
                      <li>Technical Specialists</li>
                      <li>Functional / Business Profiles</li>
                      <li>Management Professionals</li>
                      <li>Executive and Leadership Roles</li>
                    </ul>
                  </AccordionDetails>
                </Accordion>
                <Accordion>
                  <AccordionSummary
                    sx={{ fontWeight: 'bold' }}
                    expandIcon={<FontAwesomeIcon icon={faCaretDown} />}
                    aria-controls="panel4-content"
                    id="panel4-header"
                  >
                    Can I publish multiple job advertisements?
                  </AccordionSummary>
                  <AccordionDetails>
                    Yes.<br></br>
                    The number of job postings available depends on the
                    subscription or package you choose.
                  </AccordionDetails>
                </Accordion>
                <Accordion>
                  <AccordionSummary
                    sx={{ fontWeight: 'bold' }}
                    expandIcon={<FontAwesomeIcon icon={faCaretDown} />}
                    aria-controls="panel4-content"
                    id="panel4-header"
                  >
                    Can I access a talent database?
                  </AccordionSummary>
                  <AccordionDetails>
                    Not yet.<br></br>
                    This feature will be available in the near future.
                  </AccordionDetails>
                </Accordion>
                <Accordion>
                  <AccordionSummary
                    sx={{ fontWeight: 'bold' }}
                    expandIcon={<FontAwesomeIcon icon={faCaretDown} />}
                    aria-controls="panel4-content"
                    id="panel4-header"
                  >
                    Can I recruit freelancers?
                  </AccordionSummary>
                  <AccordionDetails>
                    Yes.<br></br>
                    JoberTech supports recruitment for permanent positions,
                    freelance assignments, consulting projects, and temporary
                    engagements.
                  </AccordionDetails>
                </Accordion>
                <Accordion>
                  <AccordionSummary
                    sx={{ fontWeight: 'bold' }}
                    expandIcon={<FontAwesomeIcon icon={faCaretDown} />}
                    aria-controls="panel4-content"
                    id="panel4-header"
                  >
                    How does the recruiter subscription work?
                  </AccordionSummary>
                  <AccordionDetails>
                    You can choose the package that best fits your hiring needs
                    in order to :
                    <ul>
                      <li>Publish job advertisements</li>
                      <li>Contact candidates</li>
                      <li>Increase your employer brand visibility</li>
                    </ul>
                  </AccordionDetails>
                </Accordion>
                <Accordion>
                  <AccordionSummary
                    sx={{ fontWeight: 'bold' }}
                    expandIcon={<FontAwesomeIcon icon={faCaretDown} />}
                    aria-controls="panel4-content"
                    id="panel4-header"
                  >
                    Are candidates mainly based in Switzerland?
                  </AccordionSummary>
                  <AccordionDetails>
                    The platform primarily attracts professionals interested in
                    the Swiss market, particularly French-speaking Switzerland.
                    <br></br>
                    We also welcome international candidates and have a number
                    of professionals based in German-speaking Switzerland due to
                    our client presence in that region.
                  </AccordionDetails>
                </Accordion>
                <Accordion>
                  <AccordionSummary
                    sx={{ fontWeight: 'bold' }}
                    expandIcon={<FontAwesomeIcon icon={faCaretDown} />}
                    aria-controls="panel4-content"
                    id="panel4-header"
                  >
                    How is JoberTech different from a traditional job board?
                  </AccordionSummary>
                  <AccordionDetails>
                    JoberTech goes far beyond simply publishing job
                    advertisements. The platform combines:
                    <ul>
                      <li>A specialized IT & Digital ecosystem </li>
                      <li>Intelligent matching tools </li>
                      <li>A highly targeted audience </li>
                      <li>Qualified professionals </li>
                      <li>Local talent </li>
                      <li>
                        A deep understanding of IT and Digital professions{' '}
                      </li>
                      <li>More relevant hiring outcomes </li>
                      <li>Artificial Intelligence-powered features </li>
                      <li>
                        Integrated video interviews directly within the platform{' '}
                      </li>
                      <li>
                        Simplified connections between talent and recruiters{' '}
                      </li>
                    </ul>
                    Our goal is to make recruitment faster, more relevant, and
                    more efficient for everyone involved.
                  </AccordionDetails>
                </Accordion>
                <Accordion>
                  <AccordionSummary
                    sx={{ fontWeight: 'bold' }}
                    expandIcon={<FontAwesomeIcon icon={faCaretDown} />}
                    aria-controls="panel4-content"
                    id="panel4-header"
                  >
                    Does JoberTech use Artificial Intelligence?
                  </AccordionSummary>
                  <AccordionDetails>
                    Yes.<br></br>
                    We are continuously integrating Artificial
                    Intelligence-powered features to enhance the experience for
                    both candidates and recruiters.<br></br>
                    Our goal is to simplify job searches, facilitate meaningful
                    connections, and help everyone make better-informed
                    decisions.
                  </AccordionDetails>
                </Accordion>
                <Accordion>
                  <AccordionSummary
                    sx={{ fontWeight: 'bold' }}
                    expandIcon={<FontAwesomeIcon icon={faCaretDown} />}
                    aria-controls="panel4-content"
                    id="panel4-header"
                  >
                    Can I get a salary estimate through JoberTech?
                  </AccordionSummary>
                  <AccordionDetails>
                    Yes.<br></br>
                    JoberTech offers an AI-powered salary estimation tool that
                    helps candidates assess their market value based on their
                    profile, experience, location, skills, and expertise.
                    <br></br>
                    This estimation allows professionals to better position
                    themselves in the job market and negotiate with greater
                    confidence.
                  </AccordionDetails>
                </Accordion>
                <Accordion>
                  <AccordionSummary
                    sx={{ fontWeight: 'bold' }}
                    expandIcon={<FontAwesomeIcon icon={faCaretDown} />}
                    aria-controls="panel4-content"
                    id="panel4-header"
                  >
                    How does JoberTech help companies define their hiring needs?
                  </AccordionSummary>
                  <AccordionDetails>
                    Using Artificial Intelligence, JoberTech assists recruiters
                    in defining and refining their hiring requirements.
                    <br></br>
                    The platform helps structure job expectations, identify key
                    skills, and create more accurate job descriptions in order
                    to attract the most relevant candidates.
                  </AccordionDetails>
                </Accordion>
                <Accordion>
                  <AccordionSummary
                    sx={{ fontWeight: 'bold' }}
                    expandIcon={<FontAwesomeIcon icon={faCaretDown} />}
                    aria-controls="panel4-content"
                    id="panel4-header"
                  >
                    How does JoberTech help me create a job posting?
                  </AccordionSummary>
                  <AccordionDetails>
                    Our AI-assisted tools help recruiters create or enhance job
                    advertisements by suggesting:
                    <ul>
                      <li>Required skills</li>
                      <li>Key responsibilities</li>
                      <li>Relevant technologies</li>
                      <li>Appropriate selection criteria</li>
                    </ul>
                    This saves valuable time while improving the quality,
                    accuracy, and effectiveness of job postings.
                  </AccordionDetails>
                </Accordion>
                <Accordion>
                  <AccordionSummary
                    sx={{ fontWeight: 'bold' }}
                    expandIcon={<FontAwesomeIcon icon={faCaretDown} />}
                    aria-controls="panel4-content"
                    id="panel4-header"
                  >
                    How can I get a demonstration?
                  </AccordionSummary>
                  <AccordionDetails>
                    You can try our 10-day trial offer and/or contact us
                    directly at{' '}
                    <a href="mailto:contact@jobertech.com">
                      contact@jobertech.com
                    </a>
                  </AccordionDetails>
                </Accordion>
                <Accordion>
                  <AccordionSummary
                    sx={{ fontWeight: 'bold' }}
                    expandIcon={<FontAwesomeIcon icon={faCaretDown} />}
                    aria-controls="panel4-content"
                    id="panel4-header"
                  >
                    What if I need support with a recruitment project?
                  </AccordionSummary>
                  <AccordionDetails>
                    You can send your request to{' '}
                    <a href="mailto:recrutement@jobertech.com">
                      recrutement@jobertech.com
                    </a>
                  </AccordionDetails>
                </Accordion>
                <Accordion>
                  <AccordionSummary
                    sx={{ fontWeight: 'bold' }}
                    expandIcon={<FontAwesomeIcon icon={faCaretDown} />}
                    aria-controls="panel4-content"
                    id="panel4-header"
                  >
                    What if I encounter a technical issue?
                  </AccordionSummary>
                  <AccordionDetails>
                    Please contact our support team at{' '}
                    <a href="mailto:support@jobertech.com">
                      support@jobertech.com
                    </a>
                  </AccordionDetails>
                </Accordion>
              </div>
            )}
          </Container>
        </Box>
      </Box>
    </main>
  )
}
